import { Client } from '@/common/services/Client';

import type { BillingNoteInput } from '../types/BillingNoteInput';

export async function addBillingNote(
  billingUuid: string,
  note: BillingNoteInput,
): Promise<void> {
  await Client.post<void, BillingNoteInput>({
    body: note,
    endpoint: `/billing/${billingUuid}/notes`,
  });
}
